import React from "react";
import * as CHQ from "chq";

import { EventLink } from "app/links";
import { Trans } from "app/utils";

import NotificationBody from "./NotificationBody";

type EventHostingEndedNotificationProps = {
  notification: CHQ.NotificationEventHostingEnded;
  tabIndex?: number;
};

const EventHostingEndedNotification: React.FC<EventHostingEndedNotificationProps> = ({
  notification: { entity }, tabIndex
}) => (
  <NotificationBody badge="calendar">
    <EventLink event={entity} tabIndex={tabIndex || 0} />
    {" "}
    <Trans>
      has ended and the survey is now being sent out. Make sure you check in on
      the results and add any expenses!
    </Trans>
  </NotificationBody>
);

export default EventHostingEndedNotification;
